import React, { useMemo } from 'react';
import InfoItem from '@tcs/client-portal-representative/components/molecules/AccountsInfoPanel/InfoItem';
import nFormatter from '@tcs/common/utils/nFormatter';
import { useStyles } from './style';
import { AccountSearchResult } from '@tcs/client-portal-api/types/AccountSearchResult';

interface Props {
  accounts: AccountSearchResult[];
}

const AccountsInfoPanel = ({ accounts }: Props) => {
  const classes = useStyles();

  const totalValues = useMemo(
    () =>
      accounts.reduce<{ total: number; investment: number; cash: number }>(
        (
          aggregateTotals,
          { availableCash, investmentValue }: AccountSearchResult
        ) => {
          const cash = availableCash ?? 0;
          const investment = investmentValue ?? 0;
          return {
            total: aggregateTotals.total + cash + investment,
            investment: aggregateTotals.investment + investment,
            cash: aggregateTotals.cash + cash,
          };
        },
        { total: 0, investment: 0, cash: 0 }
      ),
    [accounts]
  );

  return (
    <div className={classes.wrapper}>
      <InfoItem
        title="Total Value of Accounts"
        content={`$${nFormatter(totalValues.total, 1)}`}
        description="custodial cash + investment value"
      />
      <InfoItem
        title="Custodial cash"
        content={`$${nFormatter(totalValues.cash, 1)}`}
      />
      <InfoItem
        title="Investment value"
        content={`$${nFormatter(totalValues.investment, 1)}`}
      />
    </div>
  );
};

export default AccountsInfoPanel;
